import styled from 'styled-components';
import device from '@service-victoria/component-library/utils/device';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
  @media ${device.isDesktop} {
    margin: 0 -32px;
  }
`;

export const ButtonWrapper = styled.div`
  margin-top: 20px;
  @media ${device.isMobile} {
    margin: 20px;
  }
`;
